import { render, staticRenderFns } from "./UIintro.vue?vue&type=template&id=5d518e1d&scoped=true&"
import script from "./UIintro.vue?vue&type=script&lang=js&"
export * from "./UIintro.vue?vue&type=script&lang=js&"
import style0 from "./UIintro.vue?vue&type=style&index=0&id=5d518e1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d518e1d",
  null
  
)

export default component.exports